/*
 * rf-funeral-deliver-by.js
 * Funeral "Deliver By" auto-calculation (display + one hidden line-item property).
 *
 * Reads the selected "Funeral start time" (properties[Funeral start time]),
 * subtracts 2 hours, and writes the result into properties[Deliver By] plus a
 * small read-only helper line for the customer.
 *
 * Scope: only acts when the "Funeral start time" select exists — zero effect on
 * any other product. No validation, no shop-hours checks, no add-to-cart blocking.
 */
(function () {
  'use strict';

  function rfInit() {
    var timeSelect = document.querySelector('select[name="properties[Funeral start time]"]');
    if (!timeSelect) return; // not a funeral product -> no-op

    var hiddenInput = document.querySelector('input[name="properties[Deliver By]"]');
    if (!hiddenInput) return;

    var helper = document.querySelector('[data-rf-deliver-by-helper]');

    function rfCompute() {
      var raw = (timeSelect.value || '').trim(); // options carry trailing spaces
      var parts = raw.split(':');
      if (parts.length < 2) return;

      var h = parseInt(parts[0], 10);
      var m = parseInt(parts[1], 10);
      if (isNaN(h) || isNaN(m)) return;

      // Simple 2-hour subtraction (earliest option is 09:15, so never negative).
      var deliverBy = String(h - 2).padStart(2, '0') + ':' + String(m).padStart(2, '0');

      hiddenInput.value = 'Deliver by ' + deliverBy + ' (2 hours before service)';
      if (helper) {
        helper.textContent = 'Estimated delivery deadline: ' + deliverBy + ' (2 hours before the service).';
      }
    }

    // theme.js dispatches a bubbling 'change' on the native select when the
    // custom cc-select option changes, so this covers every pick.
    timeSelect.addEventListener('change', rfCompute);

    // Run once on load for the pre-selected first option.
    rfCompute();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rfInit);
  } else {
    rfInit();
  }
})();
